//types
import {
  SubscriptionStatus,
  PlanDetails,
  CheckoutSession,
} from "~src/types/subscription";
//api
import { ApiTypes, api } from "../common";
import { SubscriptionUsage } from "~src/types/brand";
import { getAuthToken } from "~src/utils/authService";

const SUBSCRIPTION_PATHS: ApiTypes.API = {
  status: {
    path: "api/subscription/active/",
    method: ApiTypes.HTTPMethod.GET,
  },
  usage: {
    path: "api/subscription/usage/",
    method: ApiTypes.HTTPMethod.GET,
  },
  plans: {
    path: "api/subscription/plan-prices/",
    method: ApiTypes.HTTPMethod.GET,
  },
  checkout: {
    path: "api/subscription/create-checkout-session/",
    method: ApiTypes.HTTPMethod.POST,
  },
  portalSession: {
    path: "api/subscription/create-portal-session/",
    method: ApiTypes.HTTPMethod.POST,
  },
};

export type PaymentDetails = {
  portal_url: string;
};

export const getSubscriptionUsage = async (options?: { signal?: AbortSignal }) => {
  // Check if a token exists before making the API call
  if (!getAuthToken()) {
    throw new Error("No authentication token found");
  }
  
  const endpoint = SUBSCRIPTION_PATHS.usage;
  const response = await api<SubscriptionUsage>({
    method: endpoint.method,
    url: endpoint.path,
    signal: options?.signal
  });

  return response.data;
};

export const getSubscriptionStatus = async (options?: { signal?: AbortSignal }) => {
  // Check if a token exists before making the API call
  if (!getAuthToken()) {
    throw new Error("No authentication token found");
  }
  
  const endpoint = SUBSCRIPTION_PATHS.status;
  const response = await api<SubscriptionStatus>({
    method: endpoint.method,
    url: endpoint.path,
    signal: options?.signal
  });

  return response.data;
};

export const getPlanDetails = async (options?: { signal?: AbortSignal }) => {
  // Check if a token exists before making the API call
  if (!getAuthToken()) {
    throw new Error("No authentication token found");
  }
  
  const endpoint = SUBSCRIPTION_PATHS.plans;
  const response = await api<PlanDetails[]>({
    method: endpoint.method,
    url: endpoint.path,
    signal: options?.signal
  });
  return response.data;
};

export const createCheckout = async (payload: {
  price_id: string;
  referral_code?: string;
  allow_promotion_codes?: boolean;
  discounts?: Array<{
    promotion_code: string;
  }>;
}) => {
  // Check if a token exists before making the API call
  if (!getAuthToken()) {
    throw new Error("No authentication token found");
  }
  
  const endpoint = SUBSCRIPTION_PATHS.checkout;
  
  // Create a new payload without undefined values
  const cleanPayload = {
    price_id: payload.price_id,
    ...(payload.referral_code && { referral_code: payload.referral_code }),
    ...(payload.allow_promotion_codes !== undefined && { allow_promotion_codes: payload.allow_promotion_codes }),
    ...(payload.discounts && { discounts: payload.discounts })
  };

  const response = await api<CheckoutSession>({
    method: endpoint.method,
    url: endpoint.path,
    data: cleanPayload,
  });

  return response.data;
};

export const createPortalSession = async () => {
  // Check if a token exists before making the API call
  if (!getAuthToken()) {
    throw new Error("No authentication token found");
  }
  
  const endpoint = SUBSCRIPTION_PATHS.portalSession;
  const response = await api<PaymentDetails>({
    method: endpoint.method,
    url: endpoint.path,
  });
  return response.data;
};
